var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1414_11462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7679 4.47364C12.0712 3.403 13.5902 3.40712 13.8877 4.47939L15.2763 9.48325C15.3864 9.87989 15.7086 10.182 16.1114 10.2663L21.0201 11.2942C22.1715 11.5353 22.1929 13.1718 21.0481 13.4428L16.0829 14.6186C15.6954 14.7104 15.3877 15.0042 15.2782 15.387L13.9016 20.1978C13.5967 21.2632 12.0862 21.2612 11.7841 20.195L10.3468 15.1224C10.2353 14.7288 9.91472 14.4296 9.51443 14.3453L4.94272 13.3829C3.77732 13.1375 3.77732 11.4738 4.94272 11.2285L9.51443 10.266C9.91472 10.1818 10.2353 9.8825 10.3468 9.48893L11.7679 4.47364Z",
    fill: "#717B8E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1414_11462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.837891 0.305664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/starIcon.51305f8c2c71912c27f7e8a6fabdc672.svg";
export { ForwardRef as ReactComponent };